import {fromEvent, merge, timer} from "rxjs";
import {delay, filter, map, startWith, take, tap} from "rxjs/operators";
import {ConcatScroll} from "./lib/concat-scroll";

export const initHeader = (headerConfig: {opaqueAtTop: boolean, logoAtTop: boolean} = {
    opaqueAtTop: true, logoAtTop: true} ) => {

    const $hamburger = jQuery('#hammy');
    const $header = jQuery('#wrapper-navbar');
    let active = false;
    //let diagSliders = jQuery('.mob-menu-decor');
    let body = jQuery('body');
    // console.log('WTF');
    let scrollTop;

    let cover = jQuery('.touch-dropdown-cover');
    let page1 = jQuery('.touch-dropdown-c1');
    let $touchDevParents = jQuery(".menu-page-1-c0 svg");
    let $pageContainer = jQuery('.touch-dropdown-c0');
    let $page2  = jQuery(".menu-page-2-c0");
    let $childrenC0 = $page2.find('.menu-primary-container >.menu');
    let $backToParents =$childrenC0.find('>li >.group-label svg');


    if(headerConfig.opaqueAtTop){
        $header.addClass('opaque-at-top');
    }
    if(headerConfig.logoAtTop){
        $header.addClass('logo-at-top')
    }

    fromEvent(jQuery('#desktop-menu').children(), 'mouseenter').pipe(
        tap(e => $header.addClass('ul-mouse-entered')),
        take(1)
    ).subscribe();


    fromEvent($hamburger, 'click').pipe(
        tap(e => {
                active = !active;
                if(active){
                    // diagSliders.removeAttr('style');
                    // jQuery('html').addClass('no-scroll');
                    // body.addClass('mob-menu-active');
                    /*scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    console.log('scrolltop', scrollTop);
                    setTimeout(()=> {
                        if(active){

                            body.css('position', 'fixed');
                            body.css('overflow-y', 'scroll');
                        }
                    },800);*/

                }else{
                    //body.css('position', 'static');
                    //body.css('overflow-y', 'auto');
                    //jQuery('html,body').scrollTop(scrollTop);
                    // jQuery('html').removeClass('no-scroll');
                    // body.removeClass('mob-menu-active');
                }
                // console.log('AVTIVE', active);
                active ? $hamburger.addClass('is-active') :
                    $hamburger.removeClass('is-active');
                // header.addClass('mob-menu-active');
                active ? $header.addClass('mob-menu-active') :
                    $header.removeClass('mob-menu-active');

                /*active ? $header.addClass('mob-menu-active') :
                    $header.removeClass('mob-menu-active');*/


                if(active){

                    dropMenu()
                    // closeSubMenus();
                }else{
                    closeMenu();
                }
            }
        ),
        //filter( _ => !active),
        //switchMap( _ => fromEvent(diagSliders, 'transitionend')),
        //tap( _ => diagSliders.css('visibility', 'hidden'))
    ).subscribe();
    // fromEvent(jQuery('mob-menu-decor'), )
    let scrollWatch = new ConcatScroll(100);
    scrollWatch.init();
    // scrollWatch.scrollStart$.pipe()



    const applyHeaderBg = ( isClear) => {

        isClear ? $header.removeClass('opaque') :
            $header.addClass('opaque');
    };

    const isHeaderClear = () => {
        // console.log(window.scrollY);
        return window.scrollY <= 0;
    };

    merge(scrollWatch.scrollStart$, scrollWatch.scrollStop$).pipe(
        startWith(true),
        // tap( e => console.log('SCROLL EVENT', e, (e || window.scrollY <= 0))),
        /*tap( e => (e || window.scrollY <= 0) ? $header.removeClass('opaque')
                : $header.addClass('opaque')),*/
        map(e => isHeaderClear()),
        tap(e => applyHeaderBg(e))
    ).subscribe();





    // let allDirectChildren = $page2.find('.children-c0').detach();
    console.log('BACK', $backToParents);
    let menuMap = $touchDevParents.toArray().reduce( (acc: any, cur, index) =>{
        console.log(cur);
        let id = jQuery(cur).prev().data('menu-id');
        let root =  $page2.find(`li.menu-item-${id}`);
        root.data('menu-id', id);
        acc[id] =root.detach();
        return acc;
    }, {});

    //let menuMap;
    console.log('menuMap', menuMap);
    fromEvent($touchDevParents, 'click').pipe(
        map(e => jQuery(e.currentTarget).prev()),
        map(e => e.data('menu-id')),
        tap( e => {
            //$childrenC0.detach();
            let existing = $childrenC0.find('>li');
            if( existing.get(0) ){
                menuMap[existing.data('menu-id')] = existing.detach()
            }
            console.log('prepending', menuMap[e]);
            $childrenC0.prepend(menuMap[e]);
            $pageContainer.addClass('show-children');
            let x = $page2.find(`*[data-menu-id="${e}"]`);
        }),
        delay(0),
        tap( e=> {
            //console.log('HEIGHT', $page2.get(0).scrollHeight + "px");
            let h = $page2.get(0).scrollHeight
            cover.css('transform',  `translate3d(0,${h}px,0)`);
            cover.css('transition-delay',  '0s');
            cover.css('transition-duration', '0.5s')
        })

    ).subscribe()
    fromEvent($backToParents, 'click').pipe(
        tap(e => {

            /**
             * the second menu height may have reduced after it was shown
             * (due to closing accordians)
             */
            let pos = Math.max( $page2.height(), parseTranslated(cover));
            //console.log(parseTranslated(cover));
            // console.log('page2 height..',pos);
            cover.css('transition',`none`);
            // cover.css('transition-duration','0s');
            cover.css('transform', `translate3d(0,${pos}px,0)`);
            //cover.css('transition', 'transform 0')
            // void(document.body.offsetHeight); // force reflow - transform to take effect
            //console.log(cover.get(0).offsetHeight);
        }),
        delay(0),
        tap( e => {
            let pos = page1.height();
            //cover.css('transition-duration','0.5s');
            //cover.css('transition-delay','0.5s');
            //cover.css('transition',`0.5s 0.2s ${transition}`);
            cover.css('transition',`transform 0.5s 0.2s ${transition}`);
            cover.css('transform', `translate3d(0,${pos}px,0)`);

        }),
        delay(0),
        tap( e=> {
            $pageContainer.removeClass('show-children');
        })

    ).subscribe()


    let transition = 'cubic-bezier(0.33, 1, 0.68, 1)';

    const dropMenu = () =>{
        let pos = page1.height();

        // cover.css('visibility','visible');
        cover.css('transform',`translate3d(0,${pos}px,0)`);
        //cover.css('trasn',`translate3d(0,${pos}px,0)`);
    }
    const closeMenu = () =>{
        cover.css('transform', '');
        //cover.css('transition-duration','0.5s');
        //cover.css('transition-delay','0.2s');
        cover.css('transition',`transform 0.5s 0.2s ${transition}, opacity 0.2s`);
        $header.addClass('is-closing');
        /*cover.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
            ()=>{
                if(!active){
                    $pageContainer.removeClass('show-children');
            }
        });*/
        fromEvent(cover, 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend').pipe(
            take(1),
            filter( e => !active),
            tap (e => {
                //cover.css('visibility', 'hidden');
                //console.log('TRANSITIONEND', e);
                $pageContainer.removeClass('show-children');
                $header.removeClass('is-closing');
            })
        ).subscribe();


        /*timer(500).pipe(
            tap( e =>{
                if(!active){
                    cover.css('visibility', 'hidden')
                }
            })
        ).subscribe();*/

    }
    const parseTranslated = (el) => {
        let t = el.css('transform');
        t = t && t.split(',',);
        //console.log('T', t);
        t= t.length > 0 && t[t.length -1];
        t= t && t.slice(0,-1);
        return t;
    }
}

